/* GeneratedContentHash: e93f04451aaa3877c46ec330ff34388d08ca5768c6cdb0891cc14041e45790ae */
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/
	import MessageTemplateTemplate from '@post-office/message-template--message-template-template/placements/in-app/confluence-home-banner/render';

export default {
	'message-template-template': MessageTemplateTemplate,
};
